import store from "../redux/store";
import {TOGGLE_CONFIDENCE_ON_TIMELINE} from "../redux/constants";

(window as any).toggleConfidenceOnTimeline = () => store.dispatch({type: TOGGLE_CONFIDENCE_ON_TIMELINE});